import { render, staticRenderFns } from "./UserApproval.vue?vue&type=template&id=55e73c31&scoped=true&"
import script from "./UserApproval.vue?vue&type=script&lang=js&"
export * from "./UserApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e73c31",
  null
  
)

export default component.exports